module.exports = __webpack_public_path__ + "img/banner3.fd08da18.jpg";